<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="ORIM-Book-Title">King and Joker</p>
<p class="ORIM-Book-Subtitle">A Crime Novel</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dickinson_KingandJoker_2P_MD.vue?72b8f654